import React from "react";
import TitleSubtitlePair from "../../../_utils/TitleSubtitlePair";
import UserGrade from "../UserDetailsInput/UserGrade";
import RolesTagsContainer from "../AssignUserRoletags/RolesTagsContainer";

const ConfirmUserDetails = ({ userPayload, newRoles, newTags }) => {
  function capitalizeWords(str) {
    return str
      ? str
          .toLowerCase()
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")
      : "";
  }
  return (
    <>
      <div className="flex flex-col Qsmd:flex-row px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base Qsmd:gap-gap-xl gap-gap-md">
        <div className="flex flex-col gap-gap-md Qsmd:w-width-md w-width-full lg:max-w-[var(--create-box-width)]">
          <div className="flex flex-col bg-primary-card rounded-border-radius-md gap-gap-button-l p-padding-md">
            <div className="text-text-primary font-semibold text-font-md">
              PAN Details
            </div>
            <div className="flex flex-col gap-gap-sm">
              <TitleSubtitlePair
                title={userPayload.panNumber}
                titleColor="text-primary "
                subtitle={"PAN number"}
                alignRight={false}
                hoverOption="white"
                isBold={false}
                variant="md"
              />
              <div className="bg-primary-bg h-[var(--border)] opacity-base-opacity my-margin-xs"></div>
              <TitleSubtitlePair
                title={capitalizeWords(userPayload?.account_name)}
                titleColor="text-primary "
                subtitle={"Legal name"}
                alignRight={false}
                hoverOption="white"
                isBold={false}
                variant="md"
              />
            </div>
          </div>

          <UserGrade
            userPayload={userPayload}
            previewMode={true}
          />

          <RolesTagsContainer
            labels={newRoles}
            previewMode={true}
            title={"Roles"}
          />
          <RolesTagsContainer
            isOptional={true}
            labels={newTags}
            previewMode={true}
            title={"Tags"}
          />
        </div>
        <div className="flex flex-col gap-gap-md Qsmd:w-width-md w-width-full lg:max-w-[var(--create-box-width)]">
          <div className="flex flex-col bg-primary-card rounded-border-radius-md gap-gap-button-l p-padding-md">
            <div className="text-text-primary font-semibold text-font-md">
              Contact Details
            </div>
            <div className="flex flex-col gap-gap-sm">
              <TitleSubtitlePair
                title={`+91 ${userPayload.contact_no}`}
                titleColor="text-primary "
                subtitle={"Contact number"}
                alignRight={false}
                hoverOption="white"
                isBold={false}
                variant="md"
              />
              <div className="bg-primary-bg h-[var(--border)] opacity-base-opacity my-margin-xs"></div>
              <TitleSubtitlePair
                title={userPayload?.email_id}
                titleColor="text-primary "
                subtitle={"Email ID"}
                alignRight={false}
                hoverOption="white"
                isBold={false}
                variant="md"
              />
            </div>
          </div>

          <div className="flex flex-col bg-primary-card rounded-border-radius-md gap-gap-button-l p-padding-md">
            <div className="text-text-primary font-semibold text-font-md">
              Login Details
            </div>
            <div className="flex flex-col gap-gap-sm">
              <TitleSubtitlePair
                title={userPayload.user_id}
                titleColor="text-primary "
                subtitle={"User ID"}
                alignRight={false}
                hoverOption="white"
                isBold={false}
                variant="md"
              />
              <div className="bg-primary-bg h-[var(--border)] opacity-base-opacity my-margin-xs"></div>
              <TitleSubtitlePair
                title={userPayload?.alias}
                titleColor="text-primary "
                subtitle={"Alias"}
                alignRight={false}
                hoverOption="white"
                isBold={false}
                variant="md"
              />
              <div className="bg-primary-bg h-[var(--border)] opacity-base-opacity my-margin-xs"></div>
              <TitleSubtitlePair
                title={
                  userPayload?.password
                    ? "*".repeat(userPayload.password.length)
                    : ""
                }
                titleColor="text-primary"
                subtitle="Password"
                alignRight={false}
                hoverOption="white"
                isBold={false}
                variant="md"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmUserDetails;
